import React, { FC, ReactNode } from 'react';
import { Link } from 'react-router';
import cx from 'classnames';

import { url } from 'helpers';
import { Logo } from 'components/icons';
import { Container, Layout } from 'components/ui';

import styles from './styles.module.css';

type HeaderProps = {
  className?: string;
  contentClassName?: string;
  children: ReactNode;
};

const Header: FC<HeaderProps> = ({ className, contentClassName, children }) => (
  <Layout.Header className={cx(styles.root, className)}>
    <Container className={styles.container}>
      <Link className={styles.logo} to={url.toDashboard()}>
        <Logo />
      </Link>
      <div className={cx(styles.content, contentClassName)}>{children}</div>
    </Container>
  </Layout.Header>
);

export default Header;
